import { ClusterDetails } from 'tabs/topQuestions/types/InternalTypes'
import { SelectedQuestionType } from 'tabs/topQuestions/lib/top_questions_search/topQuestionsSearchTypes'

export const getTopQuestionCount = (topQuestion: ClusterDetails,
                                    type: SelectedQuestionType) => {
  switch (type) {
    case 'faq':
      return topQuestion.faqCount
    case 'bcp':
    case 'beach':
      return topQuestion.daxCount
    case 'unknown':
      return topQuestion.unknownCount
    default:
      return topQuestion.totalQuestionCount
  }
}
